export const toggleFavoriteObject = (objectId, source, isPhysicalObject) => ({
  type: 'TOGGLE_FAVORITE_OBJECT',
  objectId,
  source,
  isPhysicalObject,
})